@if (isHtml) {
    <div
        class="break-word"
        [innerHtml]="commentMessage | prepareMessage | replaceEmojis: true"
        sbInlineImagePreview
        appInlineImageLimitWidth
        [updateStamp]="updateStamp"></div>
} @else {
    <div class="break-word" [innerHtml]="commentMessage | prepareMessage | replaceEmojis: true"></div>
}
